import loadingImg from "../../assets/progress-dots.gif";
import React from "react";

const loading = () => (<div className="loading-container">
    <img src={loadingImg} alt="Loading..."/>
</div>);


export default loading;